// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__ejaYb","content":"RecentSearches_content__1lEM7"};